import fetch_retry from "fetch-retry";
import { v4 as uuidv4 } from "uuid";
import { ErrorCode } from "../Common/Types";
import { convertToErrorDetails, logError } from "../Common/services/ErrorService";

export const fetchWithRetry = fetch_retry(window?.fetch);
export const AUTHORIZATION_SCHEME = "Bearer";

export const generateStandardHeaders = function () {
  return {
    headers: {
      "EF-Flow-Id": uuidv4(),
    },
  };
};

export const wrapWithErrorHandling = async function <ModelType, Type extends { data: ModelType }>(
  errorType: ErrorCode,
  call: () => Promise<Type>
) {
  try {
    return (await call()).data;
  } catch (error: unknown) {
    const errorDetails = convertToErrorDetails(error, errorType);
    logError(errorDetails);
    throw errorDetails;
  }
};
